import React from 'react';
import { mapCompanyToBotmarkInfo } from '../utils/botmarkCompanyInfo';
import { useBotmarkCompanyInfo } from '../hooks/useCompanies';

function BotmarkCompanyAddress({ heading, headingTag: HeadingTag = 'span', style }) {
    const { data: botmarkCompany } = useBotmarkCompanyInfo();
    const info = mapCompanyToBotmarkInfo(botmarkCompany);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10, ...style }}>
            {heading && (
                <HeadingTag style={{ display: 'flex', justifyContent: 'left' }}>
                    <b>{heading}</b>
                </HeadingTag>
            )}
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: 5 }}>
                <span>{info.name}</span>
            </span>
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: 5 }}>
                <span>{info.street}</span>
            </span>
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: 5 }}>
                <span>{info.city}{info.city && info.state ? ', ' : ''}{info.state}</span>
            </span>
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: 5 }}>
                <span>{info.zip}{info.zip && info.country ? ', ' : ''}{info.country}</span>
            </span>
            {info.email && (
                <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: 5 }}>
                    <span>{info.email}</span>
                </span>
            )}
            {info.phoneNumber && (
                <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: 5 }}>
                    <span>{info.phoneNumber}</span>
                </span>
            )}
        </div>
    );
}

export default BotmarkCompanyAddress;
